// src/core/services/appealsService.ts — public appeal submission (no auth required).
import { api } from '@/core/lib/apiClient';

export interface AppealSubmission {
  username: string;
  password: string;
  reason: string;
}

export const appealsService = {
  /**
   * Submit a sanction appeal. The user authenticates with their credentials
   * (not a session cookie) so blocked users can still file appeals.
   * Resolves on 201; throws ApiError on 401 (bad creds), 409 (duplicate), 400 (not sanctioned).
   */
  submit: (fields: AppealSubmission): Promise<{ detail: string }> =>
    api('/appeals', { method: 'POST', body: fields }),
} as const;
